export enum GeoReferencerCadMode {
    WaitingForFile = "waiting_for_file",
    ClippingAndLayerExclusions = "clipping_and_layer_exclusions",
    LocationPicker = "location_picker",
    Positioning = "positioning",
    LayerExclusions = "layer_exclusions",
    Perimeter = "perimeter",
}
